<div class="container-fluid">
  <div class="page-header">
    <h1>{{translate.instant('pages.unauthorizedMsg')}}</h1>
  </div>
</div>

